module.exports = __webpack_public_path__ + "img/Dantam Hair 02.0d41bc2a.jpg";